import { CircularProgress } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { externalSignInTaxis } from "../../redux/actions/authActions";
import ls from "local-storage";
import {
  LOCAL_STORAGE_KEY_NAME_APPLKINDID,
  LOCAL_STORAGE_KEY_NAME_FOR_ME,
} from "./login/constants";
import GovGrDrawerMenu from "../../components/GovGrDrawerMenu";
import GovGrLoader from "../../components/GovGrLoader";

const ExternalCallback = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const history = useHistory();
  const code = queryParams.get("code");
  const dispatch = useDispatch();
  useEffect(() => {
    const a = async () => {
      try {
        // console.log("ExternalCallback ", code);
        await dispatch(externalSignInTaxis(code));

        const applKindId = ls.get(LOCAL_STORAGE_KEY_NAME_APPLKINDID);
        const forMe = ls.get(LOCAL_STORAGE_KEY_NAME_FOR_ME);

        if (applKindId || forMe) {
          history.push(`/new-application/${applKindId}/${forMe}`);
        } else {
          history.push(`/gdprpage`);
        }
      } catch (error) {
        // console.log(error);
        history.push(`/500`);
      }
    };
    a();
  }, []);

  return (
    <GovGrDrawerMenu apptitle="E-θυρίδα Ναυτικού" hiddenmenu={true}>
      <GovGrLoader />
    </GovGrDrawerMenu>
  );
};

export default ExternalCallback;
